const el = document.createElement('div');

export default function escapeHTML (string) {
  el.textContent = string;
  return el.innerHTML;
}
